import { render } from "./manage-notification.vue?vue&type=template&id=2e16a46e&scoped=true&ts=true"
import script from "./manage-notification.vue?vue&type=script&lang=ts"
export * from "./manage-notification.vue?vue&type=script&lang=ts"

import "./manage-notification.vue?vue&type=style&index=0&id=2e16a46e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e16a46e"]])

export default __exports__